import { Authentication, IAuthentication } from 'spa-auth-plugin';
import { getEnvVar } from '@/utils/env';

const JWT_TOKEN_URL = getEnvVar('VITE_HYBRIS_AUTH_TOKEN_URL');
const JWT_KEY_URL = getEnvVar('VITE_HYBRIS_AUTH_JWK_URL');
const JWT_AUD = getEnvVar('VITE_JWT_AUD');
const JWT_ISS = getEnvVar('VITE_JWT_ISS');
const JWT_REFRESH_RATE = getEnvVar('VITE_JWT_REFRESH_RATE') ?? '0';
const JWT_EXPIRY_THRESHOLD = getEnvVar('VITE_JWT_EXPIRY_THRESHOLD') ?? '0';

const auth = Authentication;

let isInitialized = false;

// Lazy initialization as the context (env.) may not be ready.
// Then, delayed as far possible, on demand...
const authFactory = () => {
  const getInstance = (): IAuthentication => {
    if (!isInitialized) {
      doConfigure();
      isInitialized = true;
    }
    return auth;
  };

  return {
    getInstance
  };
};

const doConfigure = () => {
  configure(auth);
};

const configure = (auth: IAuthentication) => {
  // eslint-disable-next-line no-console
  console.info('Initialize Auth...');
  auth.configure({
    tokenURL: JWT_TOKEN_URL,
    jwkUrl: JWT_KEY_URL,
    jwtAud: JWT_AUD,
    jwtIss: JWT_ISS,
    tokenRefreshRate: parseInt(JWT_REFRESH_RATE, 10),
    tokenExpiryThreshold: parseInt(JWT_EXPIRY_THRESHOLD, 10)
  });
};

export default authFactory;
